// Scheduler worker memory, as the Scheduler Monitor shows it. The worker
// records each job run's RSS at start and end (scheduler_job_status) and one
// sample a minute with the jobs running at that moment (scheduler_memory_samples).

const signed = (value) => (value > 0 ? `+${value}` : `${value}`);

// "300 → 420 MB (+120)" for the last run, or null when the run carries no memory.
export function lastRunMemory(row) {
    if (row.last_rss_start_mb == null || row.last_rss_end_mb == null)
        return null;
    const delta = row.last_rss_delta_mb != null ? row.last_rss_delta_mb : row.last_rss_end_mb - row.last_rss_start_mb;
    return `${row.last_rss_start_mb} → ${row.last_rss_end_mb} MB (${signed(delta)})`;
}

// The largest growth seen across this job's runs, or null.
export function maxMemoryGrowth(row) {
    return row.max_rss_delta_mb != null ? signed(row.max_rss_delta_mb) : null;
}

// "RSS 610 MB · container 880 / 2048 MB (43%)" for the worker banner, or null.
export function workerMemory(worker, labels) {
    if (!worker || worker.rss_mb == null)
        return null;
    const parts = [`${labels.rss} ${worker.rss_mb} MB`];
    if (worker.container_mb != null) {
        const limit = worker.container_limit_mb;
        const share = limit ? ` (${Math.round(100 * worker.container_mb / limit)}%)` : '';
        parts.push(`${labels.container} ${worker.container_mb}${limit ? ' / ' + limit : ''} MB${share}`);
    }
    return parts.join(' · ');
}

const clock = (value) => {
    const date = new Date(value);
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

// chart.js line data: container and RSS over time, plus the container limit as
// a flat line when the worker reports one.
export function memoryChartData(samples, labels) {
    const rows = samples || [];
    const datasets = [
        {label: labels.container, data: rows.map(sample => sample.container_mb), borderColor: '#2563eb',
         backgroundColor: 'rgba(37, 99, 235, 0.08)', fill: true, pointRadius: 0, borderWidth: 1.5, spanGaps: true},
        {label: labels.rss, data: rows.map(sample => sample.rss_mb), borderColor: '#16a34a',
         pointRadius: 0, borderWidth: 1.5, spanGaps: true},
    ];
    const limits = rows.map(sample => sample.container_limit_mb).filter(limit => limit != null);
    if (limits.length)
        datasets.push({label: labels.container_limit, data: rows.map(sample => sample.container_limit_mb),
                       borderColor: '#dc2626', borderDash: [6, 4], pointRadius: 0, borderWidth: 1, spanGaps: true});
    return {labels: rows.map(sample => clock(sample.at)), datasets: datasets};
}

// The jobs that were running at a sample, for the chart tooltip.
export function runningJobsAt(samples, index) {
    const sample = (samples || [])[index];
    return (sample && sample.running_jobs) || [];
}
